import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaYoutube,
  FaFileAlt,
  FaLock,
  FaHandshake
} from "react-icons/fa";


const Footer = () => {
  return (
    <FooterContainer>
<FooterTop>
  <Logo>
    <img src="/Logo2.png" alt="Logo" />
  </Logo>

<CenterLinks>
  {/* Regulamin — download the PDF */}
  <FooterLink
    as="a"
    href="/Regulamin.pdf"
    download="Regulamin_analizyiraporty.pdf"
  >
    <FaFileAlt /> Regulamin
  </FooterLink>

  {/* Polityka prywatności — open OR download (choose one) */}
  {/* If you want direct download: */}
  <FooterLink
    as="a"
    href="/Polityka.pdf"
    download="Polityka_prywatnosci_analizyiraporty.pdf"
  >
    <FaLock /> Polityka prywatności
  </FooterLink>

  {/* If you prefer to still allow viewing in a new tab instead, keep this instead of the block above:
  <FooterLink as="a" href="/Polityka.pdf" target="_blank" rel="noopener noreferrer">
    <FaLock /> Polityka prywatności
  </FooterLink>
  */}

  <FooterLink to="/partner"><FaHandshake /> Zostań partnerem</FooterLink>
</CenterLinks>


  <SocialIcons>
    <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
      <FaFacebookF />
    </a>
    <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">
      <FaLinkedinIn />
    </a>
    <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer">
      <FaYoutube />
    </a>
  </SocialIcons>
</FooterTop>



      <FooterBorder />

      <FooterBottom>
        <BottomText>© 2026 analizyiraporty.pl. Wszelkie prawa zastrzeżone.</BottomText>
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;

const FooterContainer = styled.footer`
  background: url("/back.jpg") no-repeat center center fixed;
  background-size: cover;
  padding: 2rem 2rem;
  border-top: 1px solid #e5e7eb;
`;


const FooterBorder = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e5e7eb;
  margin: 2rem 0 1rem;
`;

const FooterBottom = styled.div`
  text-align: center;
`;

const BottomText = styled.p`
  font-size: 0.875rem;
  color: #6b7280;
`;


const FooterLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.95rem;
  color: black;
  text-decoration: none;
  transition: color 0.3s ease;

  svg {
    font-size: 1rem;
  }

  &:hover {
    color: #3bc3cc;
  }
`;

const FooterTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem;
  padding: 1rem 0;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

const Logo = styled.div`
  img {
    width: 120px;
    height: auto;
  }
`;

const CenterLinks = styled.div`
  display: flex;
  gap: 1.2rem;
  flex-wrap: wrap;
  justify-content: center;

a {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.95rem;
  color: #3bc3cc;
  text-decoration: none;
  transition: color 0.3s ease;

  svg {
    font-size: 1rem;
    color: #3bc3cc;
    transition: color 0.3s ease;
  }

  &:hover {
    color: black;

    svg {
      color: black;
    }
  }
}

`;

const SocialIcons = styled.div`
  display: flex;
  gap: 1rem;

a {
  color: #3bc3cc;
  font-size: 1.2rem;
  transition: color 0.3s ease;

  &:hover {
    color: black;
  }
}


  @media (max-width: 768px) {
    justify-content: center;
  }
`;

